import { EditorStarterItem } from '../../items/item-type';
import { TrackType } from '../../state/types';
import { overlapsRight } from '../../timeline/utils/drag/collision';
import { getTrackIndexOfItem } from '../../timeline/utils/get-track-index-of-item';

/**
 * 재생 속도를 변경할 때 아이템이 유지할 수 있는 최대 안전 지속 시간을 계산함.
 * 재생 속도를 줄이면(재생이 느려지면) 아이템 지속 시간이 자연스럽게 늘어남.
 * 이 함수는 다른 아이템과 충돌하지 않는 최대 지속 시간을 찾음.
 */
export const getMaxSafeDurationInFrames = ({
  item,
  tracks,
  items,
  newDuration,
}: {
  item: EditorStarterItem;
  tracks: TrackType[];
  items: Record<string, EditorStarterItem>;
  newDuration: number;
}): number => {
  const trackIndex = getTrackIndexOfItem({
    itemId: item.id,
    tracks,
  });

  if (trackIndex === -1 || !tracks[trackIndex]) {
    return newDuration;
  }

  const track = tracks[trackIndex];
  const otherItemsOnTrack = track.items
    .filter((id) => id !== item.id)
    .map((id) => items[id]);

  // 충돌할 수 있는 가장 가까운 오른쪽 아이템을 찾음
  let maxSafeDuration = newDuration;

  for (const otherItem of otherItemsOnTrack) {
    // 이 아이템을 연장하면 충돌이 발생하는지 확인
    if (
      otherItem &&
      overlapsRight({
        item: otherItem,
        from: item.from,
        durationInFrames: newDuration,
      })
    ) {
      // 충돌하지 않는 최대 지속 시간을 계산
      const maxDurationBeforeCollision = otherItem.from - item.from;
      maxSafeDuration = Math.min(maxSafeDuration, maxDurationBeforeCollision);
    }
  }

  return Math.max(1, maxSafeDuration);
};
